import React, { useMemo, useEffect } from 'react';
import { renderIntervalTimeline, getVisibleMarkersInfo } from './renderTimeline';
import { baseDate } from '../utils/settings';
// Timeline bileşeni
const IntervalTimeline = ({ 
  scrollPosition, 
  interval, 
  visibleWidth, 
  events = [], 
  categories, 
  stylings, 
  onMarkerCountUpdate,
  scrollPositionY
}) => {
  // Günlük görünüm için daha yüksek alan
  const isDayView = interval.value === 'day' || interval.value === '6hours';
  
  // Pre-filter events if the shouldRender property exists
  const renderableEvents = useMemo(() => {
    if (events.length === 0) return [];
    
    // Always filter events based on shouldRender property
    const filtered = events.filter(event => event.shouldRender !== false);
    // console.log(`IntervalTimeline: Rendering ${filtered.length} out of ${events.length} events`);
    return filtered;
  }, [events]);
  
  // Update the marker count and report it to parent
  useEffect(() => {
    const count = getVisibleMarkersInfo(scrollPosition, interval, visibleWidth);
    
    if (onMarkerCountUpdate) {
      onMarkerCountUpdate(count);
    }
  }, [scrollPosition, interval, visibleWidth, baseDate]);
  
  // CSS stilleri - katman yönetimi için - useMemo ile optimize ediyoruz
  const containerStyle = useMemo(() => ({
    position: 'absolute',
    left: '0',
    right: '0',
    bottom: '3px',
    height: '45px', // Tüm çizgilerde etiket olacağı için yüksekliği arttırdık
    pointerEvents: 'auto', // Mouse olaylarını ETKİNLEŞTİR
    isolation: 'isolate', // Katman yönetimi - çakışmaları önle
    overflow: 'visible', // Taşma olsun, böylece timeline kaydırıldığında öğeler görünür kalır
    zIndex: isDayView ? 3 : 5 // Günlük görünümde daha düşük z-index
  }), [isDayView]);

  const markersContainerStyle = useMemo(() => ({
    position: 'absolute',
    left: '0',
    top: '0',
    height: '100%',
    width: '100%',
    pointerEvents: 'auto', // Mouse olaylarını ETKİNLEŞTİR
    zIndex: isDayView ? 1 : 2, // Günlük görünümde daha düşük z-index
  }), [isDayView]);

  const baseLineStyle = useMemo(() => ({
    position: 'absolute',
    left: '0',
    right: '0',
    bottom: '0',
    height: '1px',
    backgroundColor: '#888', // Cetvel alt çizgisi
    zIndex: 1
  }), []);

  return (
    <div style={containerStyle}>
      {/* Zemin - cetvel alt çizgisi */}
      <div style={baseLineStyle} />
      
      {/* Noktalar için container */}
      <div style={markersContainerStyle}>
        {/* Interval timeline render */}
        {renderIntervalTimeline(
          scrollPosition,
          interval,
          visibleWidth,
          renderableEvents,
          categories,
          stylings,
          scrollPositionY
        )}
      </div>
    </div>
  );
};

// React.memo ile sarmak gereksiz yeniden renderları önler
export default React.memo(IntervalTimeline); 